// NavigationBar.tsx
import React, { useEffect } from "react";
import { Navbar, Nav, Dropdown, NavDropdown } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import axios from "axios";
import { useStore } from "../store";
import LanguageSwitcher from "./languageSwitcher";
import { useTranslation } from 'react-i18next';

function NavigationBar() {
  const navigate = useNavigate();
  const { auth, setAuth } = useStore();
  const { t } = useTranslation("NavigationBar");

  return (
    <div>
      <Navbar
        bg="dark"
        variant="dark"
        style={{
          display: "flex",
          justifyContent: auth ? "space-between" : "end",
          paddingRight: "2rem",
          paddingLeft: "2rem",
        }}
      >
        {auth && (
          <div style={{ display: "flex", alignItems: "flex-end" }}>
            <Navbar.Brand href="/upload">
              <div>
                <AiOutlineHome size={40} color="white" />
              </div>
            </Navbar.Brand>

            <Nav>
              <Nav.Link as={NavLink} to="/datasource">
                {t("DataSource")}
              </Nav.Link>

              <Nav.Link as={NavLink} to="/upload">
                {t("DataAnalytics")}
              </Nav.Link>

              <Nav.Link as={NavLink} to="/usecase">
                {t("UseCase")}
              </Nav.Link>
            </Nav>
          </div>
        )}
        <Nav style={{ justifySelf: "flex-end" }}>
            <LanguageSwitcher />
            {auth && (
          <NavDropdown title="User" style={{ width: "10rem" }}>
            <NavDropdown.Item style={{ width: "10rem" }}>

            </NavDropdown.Item>
            <NavDropdown.Item style={{ width: "10rem" }}
            onClick={() => {
              navigate("/billing");
            }
            }

            >
              {t("BillingOption")}
            </NavDropdown.Item>
            <NavDropdown.Item
              style={{ width: "10rem" }}
              onClick={() => {
                setAuth(false);
                localStorage.removeItem("tokenLida");
                navigate("/login");
              }}
            >
              {t("Logout")}
            </NavDropdown.Item>
          </NavDropdown>)}
        </Nav>
      </Navbar>
    </div>
  );
}

export default NavigationBar;
